import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'

import type { DashboardItemsWithQueriesLoaded } from 'recoil/atoms'
import { dashboardItemsWithQueriesLoadedState } from 'recoil/atoms'

type useDashboardItemsWithQueriesLoadedArgs = {
  id: string
  isLoaded: boolean
  data?: DashboardItemsWithQueriesLoaded['data']
  body: DashboardItemsWithQueriesLoaded['body']
  type: string
  headers: DashboardItemsWithQueriesLoaded['headers']
  hasErrors?: boolean
}

export const useDashboardItemsWithQueriesLoaded = ({
  id,
  isLoaded,
  data,
  body,
  headers,
  hasErrors,
}: useDashboardItemsWithQueriesLoadedArgs) => {
  const setDashboardItemsWithQueriesLoaded = useSetRecoilState(dashboardItemsWithQueriesLoadedState)
  useEffect(() => {
    // FIXME: This is a workaround to avoid this code runs before setDashboardItemsWithQueriesLoaded in Gridstackwrapper
    setTimeout(() => {
      setDashboardItemsWithQueriesLoaded(prevState => {
        return prevState.map(item => {
          if (item.id === id) {
            return {
              id,
              body,
              type: item.type,
              headers,
              data,
              isLoaded,
              hasErrors,
            }
          }
          return item
        })
      })
    }, 0)
  }, [id, isLoaded, setDashboardItemsWithQueriesLoaded, data, body, headers, hasErrors])
}
